var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SignupTemplate",
    [
      _c(
        "FpFlexGrid",
        { attrs: { compact: "", "space-around": "" } },
        [
          _c(
            "FpFlexGridItem",
            [
              _c("FpHeader1", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("signup.common.welcome")) +
                    "\n      "
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "FpFlexGridItem",
            [
              _c("FpBody", [
                _vm._v(_vm._s(_vm.$t("signin.withoutPassword.subheader")))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.error
            ? _c(
                "FpFlexGridItem",
                [
                  _c(
                    "FpAlert",
                    {
                      attrs: {
                        "data-testid": _vm.TEST_IDS.ERROR_ALERT,
                        error: ""
                      }
                    },
                    [
                      _c("FpBody", [
                        _vm._v(_vm._s(_vm.$t("signup.common.genericError")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.noInviteError
            ? _c(
                "FpFlexGridItem",
                [
                  _c(
                    "FpAlert",
                    {
                      attrs: {
                        "data-testid": _vm.TEST_IDS.ERROR_ALERT,
                        error: ""
                      }
                    },
                    [
                      _c("FpBody", [
                        _vm._v(_vm._s(_vm.$t("signin.noInvite.error")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "FpFlexGridItem",
            [
              _c("FpInput", {
                attrs: {
                  "data-testid": _vm.TEST_IDS.EMAIL_INPUT,
                  disabled: _vm.loading,
                  error: _vm.$v.email.$error,
                  label: _vm.$t("signup.common.emailLabel"),
                  name: "email"
                },
                on: {
                  blur: _vm.trackEmailInput,
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.continueWithEmail($event)
                  }
                },
                model: {
                  value: _vm.email,
                  callback: function($$v) {
                    _vm.email = typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "email"
                }
              }),
              _vm._v(" "),
              _vm.$v.email.$error
                ? _c(
                    "FpHint",
                    {
                      attrs: {
                        "data-testid": _vm.TEST_IDS.EMAIL_REQUIRED_HINT,
                        error: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("signup.common.validation.email")) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "FpFlexGridItem",
            [
              _c(
                "FpButton",
                {
                  attrs: {
                    "data-testid": _vm.TEST_IDS.LOGIN_BUTTON,
                    loading: _vm.loading,
                    fluid: ""
                  },
                  on: { click: _vm.continueWithEmail }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("common.button.continue")) +
                      "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }